/**
 * @generated SignedSource<<5a7a5a06e52ec5f6cac80f4771b820b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastFocusSubjectNewInput = {
  detailItemId?: string | null;
  nodeId: string;
  scale?: number | null;
  transformX?: number | null;
  transformY?: number | null;
};
export type useFocusEndTVMutation$variables = {
  storecastId: string;
  subject?: StorecastFocusSubjectNewInput | null;
};
export type useFocusEndTVMutation$data = {
  readonly dashboard: {
    readonly setNewFocus: {
      readonly subject: {
        readonly detailItemId: string | null;
        readonly nodeId: string;
      };
    } | null;
  };
};
export type useFocusEndTVMutation = {
  response: useFocusEndTVMutation$data;
  variables: useFocusEndTVMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subject"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "subject",
            "variableName": "subject"
          }
        ],
        "concreteType": "StorecastNewFocus",
        "kind": "LinkedField",
        "name": "setNewFocus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastNewFocusSubject",
            "kind": "LinkedField",
            "name": "subject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detailItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFocusEndTVMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFocusEndTVMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e71df9cd3c4359dd3706c2bf0ae4276",
    "id": null,
    "metadata": {},
    "name": "useFocusEndTVMutation",
    "operationKind": "mutation",
    "text": "mutation useFocusEndTVMutation(\n  $storecastId: ID!\n  $subject: StorecastFocusSubjectNewInput\n) {\n  dashboard(dashboardId: $storecastId) {\n    setNewFocus(subject: $subject) {\n      subject {\n        nodeId\n        detailItemId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd93b40abbb2b32f15d4ff182320b5af";

export default node;
